import Icon from '../common/Icon.tsx'
import React from 'react'
import { useHistoryStore } from '../../shared/store/history.store.tsx'
import Button from '../common/Button.tsx'

const HistoryControls: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const undo = useHistoryStore((state) => state.undo)
  const redo = useHistoryStore((state) => state.redo)

  return (
    <div className="flex rounded-sm">
      <Button disabled={isLoading} onClick={undo} squared>
        <Icon name="undo" />
      </Button>
      <Button disabled={isLoading} onClick={redo} squared>
        <Icon name="redo" />
      </Button>
    </div>
  )
}

export default React.memo(HistoryControls)
